import { LOGIN_AUTH } from 'constants/routeNames';
import logo from 'assets/images/logo_simac_qr.png';
import './HeaderPortalPublico.scss';
import { Link } from 'react-router-dom';
// import { HomeFilled } from '@ant-design/icons';
import Icono from 'components/Icono/Icono';

export const HeaderPortalPublico = () => {
  return (
    <div className="containerHeaderPortal">
      <img
        src={logo}
        className="logoHeaderPortal"
        alt="LogoHeaderSIMAC"
        style={{ width: 45, height: 40 }}
      />
      <div className="separator" />
      <div className="header-portal-data">
        <span className="nombreSistema">
          Portal de descargas de resultados del Sistema Integral de <br />
          Monitoreos de Actividades de Campo (SIMAC).
        </span>
        <Link to={LOGIN_AUTH} className="btn-back-home" title="Inicio" alt="Inicio">
          <Icono iconName="home" size={40} color="#D5007F" />
        </Link>
      </div>
    </div>
  );
};
